"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const PaginationResultsBlock_1 = __importDefault(require("@Components/PaginationResultsBlock"));
const SearchResultPartyDetailsCard_1 = __importDefault(require("@Components/PublicSearch/SearchResultPartyDetailsCard"));
const PaginationAndLimit_1 = __importDefault(require("@Components/PaginationAndLimit"));
const PartyResultsTable = (props) => {
    const { onTitleClick, publicSearchPartyStore, setLoading } = props;
    const onPageChange = (pagination) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        yield publicSearchPartyStore.searchForParties(pagination).finally(() => setLoading(false));
    });
    const onLimitChange = (newLimit) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        yield publicSearchPartyStore.setCurrentResultsPerPageLimit(newLimit).finally(() => setLoading(false));
    });
    const count = publicSearchPartyStore.totalNumberOfResults;
    const searchResultPartyDetails = publicSearchPartyStore.searchResultPartyDetails;
    return (react_1.default.createElement("div", { className: "party-results-table" }, searchResultPartyDetails && count > 0 && (react_1.default.createElement("div", { className: "found-items-wrapper" },
        react_1.default.createElement(PaginationResultsBlock_1.default, { totalResults: count, workNumTitles: publicSearchPartyStore.numTitles, justResults: false }),
        react_1.default.createElement("section", { className: 'items-container' }, searchResultPartyDetails.map((partyDetails, index) => (react_1.default.createElement(SearchResultPartyDetailsCard_1.default, { key: index, partyDetails: partyDetails, onTitleClick: onTitleClick })))),
        react_1.default.createElement(PaginationAndLimit_1.default, { paginationInfo: publicSearchPartyStore.publicSearchByPartyCriteriaPaginationInfo, onPageChange: onPageChange, onLimitChange: onLimitChange, count: count, limit: publicSearchPartyStore.currentPartyResultsPerPageLimit })))));
};
exports.default = (0, mobx_react_1.observer)(PartyResultsTable);
